// Сортування меню (новий дизайн): «Популярні» — порядок, у якому меню віддає бекенд (orderBy('order'), як розставили в адмінці),
// «Найдешевші» й «Найдорожчі» — за ціною, яку показує картка (Product.vue)
// icon — ключ ICONS у src/v2icons.js
export const SORTS = [
    { key: 'popular', label: 'Популярні', icon: 'thumbsUp' },
    { key: 'cheap', label: 'Найдешевші', icon: 'sortAsc' },
    { key: 'expensive', label: 'Найдорожчі', icon: 'sortDesc' }
];

// Піца — ціна 30 см (або 50 см, коли 30 немає), решта — price
export function cardPrice(product) {
    const price = product.category_id == 1
        ? Number(product.price_30) || Number(product.price_50)
        : Number(product.price) || Number(product.price_30);
    return price > 0 ? price : null;
}

// Швидкі кнопки піци (show_main) — як у застосунку: за полем «Порядок» інгредієнта від більшого до меншого
// (застосунок: b.order - a.order), однакові числа — як віддає бекенд
export function sortMainIngredients(list) {
    return list
        .map((ingredient, i) => ({ ingredient, i }))
        .sort((a, b) => (Number(b.ingredient.order) || 0) - (Number(a.ingredient.order) || 0) || a.i - b.i)
        .map(row => row.ingredient);
}

// Товари без ціни — у кінці; однакова ціна — як у меню
export function sortProducts(items, key) {
    if (key != 'cheap' && key != 'expensive') return items;
    const dir = key == 'cheap' ? 1 : -1;
    return items
        .map((product, i) => ({ product, i, price: cardPrice(product) }))
        .sort((a, b) => (a.price === null) - (b.price === null)
            || (a.price === null ? 0 : (a.price - b.price) * dir)
            || a.i - b.i)
        .map(row => row.product);
}
